var _defs, _g, _path, _rect, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpercenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0;}.cls-2{opacity:0.13;}.cls-3{fill:red;}.cls-4{opacity:0.1;}.cls-5{fill:#ff6700;}.cls-6{opacity:0.09;}.cls-7{opacity:0.21;}.cls-8{fill:currentColor;}.cls-9{fill:currentColor;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "26_\u5E2E\u52A9\u4E2D\u5FC3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.06,
    y: 3.9,
    width: 56,
    height: 56
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 32.05,
    cy: 31.9,
    r: 28
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.06,
    y: 7.9,
    width: 56,
    height: 48
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 8.06,
    y: 3.9,
    width: 48,
    height: 56
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M53.5,26.08H38a4,4,0,0,1-4-4V7a2,2,0,0,1,4,0V22.08H53.5a2,2,0,0,1,0,4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 43.29,
    y: 0.3,
    width: 4,
    height: 28.44,
    rx: 1.97,
    transform: "translate(3.15 36.57) rotate(-45.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52,59.93h-40a4,4,0,0,1-4-4v-48a4,4,0,0,1,4-4H36a2,2,0,0,1,0,4H12.06V56l40,0,0-32.72a2,2,0,1,1,4,0V56A4,4,0,0,1,52,59.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.07,44.53a.43.43,0,0,1-.43.48H28.87a.58.58,0,0,1-.58-.6c.16-4.36,2.06-4.72,3.41-5.92a5.29,5.29,0,0,0,2.43-4.25c-.09-2.69-4.79-4.68-6.71-.46a1.79,1.79,0,0,1-2.21,1h0a1.76,1.76,0,0,1-1.08-2.28A6.73,6.73,0,0,1,31.26,28s4.91-.06,6.27,5.62l.06.65c-.13,2.71-.73,4.49-3.73,6.64A3.85,3.85,0,0,0,32.07,44.53Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 30.42,
    cy: 48.59,
    r: 2.23
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpercenter);
export default __webpack_public_path__ + "static/media/helpercenter.ad489e9a.svg";
export { ForwardRef as ReactComponent };